<section class="not-found">
  <div id="title">Page non trouvée</div>
  <div class="circles">
    <p>404<br>
     <small>CONTENU NON TROUVE</small>
    </p>
    <span class="circle big"></span>
    <span class="circle med"></span>
    <span class="circle small"></span>
  </div>
</section>
